export const navbarState = (newState) => {
  return (dispatch) => {
    dispatch({
      type: "NAVBAR_STATE_CHANGE",
      payload: newState,
    });
  };
};

export const updateSelectedJob = (newState) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_SELECTED_JOB",
      payload: newState,
    });
  };
};

export const updateUserFromCreateJob = (newState) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_USER_FROM_CREATE_JOB",
      payload: newState,
    });
  };
};

export const updateUserFromViewJob = (newState) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_USER_FROM_VIEW_JOB",
      payload: newState,
    });
  };
};
